/**
 * WP 画像ブロックにboxerを付与
 * @param {string} classname - add classname
 */
export function wpAddImageBoxer (classname = 'boxer') {
  const imageBlocks = document.querySelectorAll('.wp-block-image');
  imageBlocks.forEach(block => {
    const link = block.querySelector('a');
    if (link) {
      link.classList.add(classname);
    }
  });
}

/**
 * WP ギャラリーブロックにデータ属性を付与
 */
export function wpAddGallaryBoxer () {
  const galleries = document.querySelectorAll('.wp-block-gallery');

  galleries.forEach((gallery, index) => {
    const uniqueDataValue = `gallery-${index + 1}`;
    const imageBlocks = gallery.querySelectorAll('.wp-block-image');
    imageBlocks.forEach(block => {
      const link = block.querySelector('a');
      if (link) {
        link.setAttribute('data-gallery', uniqueDataValue);
      }
    });
  });
}